import { useEffect, useState } from "react";
import ListTable from "../../../molecules/ListTable";
import { Link, useNavigate } from "react-router-dom";
import { useAdminReviewList, useAdminReviewResultList, useDeleteReview, useModifyReviewStatus } from "../../../../api/admin/review/hooks";
import { Select, SelectOption } from "../../../atoms/Select";
import Button from "../../../atoms/Button";
import Modal from "../../../organisms/Modal";
import { useDispatch } from "react-redux";
import { closeLoader, openLoader } from "../../../../store/loaderSlice";
import UserProfileSimple from "../../../molecules/UserProfileSimple";
import styled, { css } from "styled-components";
import IconCircle from "../../../atoms/IconCircle";
import { showAlert } from "../../../../reducer/alertSlice";
import { showConfirm } from "../../../../reducer/confirmSlice";
import Paging from "../../../organisms/Paging";
import StatusBadge from "../../../atoms/StatusBadge";

/**
 * 전체 리뷰 목록
 * - 관리자용 화면
 */
//TOOD 진행도에 아직 미완료한 인원 표시
const ReviewList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [pageNum, setPageNum] = useState(1);
    const [viewCount, setViewCount] = useState(15);

    const [reviewerList, setReviewerList] = useState([]);
    const [revieweeList, setRevieweeList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data: reviewList, isLoading, refetch } = useAdminReviewList(pageNum, viewCount);
    const { mutate: modifyReviewStatus, isLoading: isModifyStateLoading } = useModifyReviewStatus();
    const { mutate: deleteReview, isLoading: isDeleteReviewLoading } = useDeleteReview();

    useEffect(() => {
        isLoading || isModifyStateLoading ? dispatch(openLoader()) : dispatch(closeLoader());
    }, [dispatch, isLoading, isModifyStateLoading]);

    const reviewStatusChangeHandler = (e, reviewIdx) => {
        modifyReviewStatus(
            {
                reviewIdx: reviewIdx.toString(),
                status: e.target.value,
            },
            {
                onSuccess: () => {
                    refetch();
                },
            }
        );
    };

    const reviewerOpenHandler = (el) => {
        setReviewerList(el.reviewer);
        setIsModalOpen(true);
    };

    const reviewClickHander = (reviewIdx, status) => {
        switch (status) {
            // 대기, 진행 -> 리뷰 수정
            case "1":
            case "2":
                navigate(`/admin/review/detail/${reviewIdx}`);
                break;
            // 확인, 종료 -> 리뷰 결과
            case "3":
            case "4":
                navigate(`/admin/review/result/detail/${reviewIdx}`);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <Modal title="리뷰어" isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }} className="center">번호</th>
                            <th style={{ width: "90%" }}>Knotter</th>
                        </tr>
                    </thead>
                    {reviewerList.map((el, seq) => (
                        <tbody>
                            <tr>
                                <td className="seq">{seq + 1}</td>
                                <td>
                                    <UserProfileSimple user={el} />
                                </td>
                            </tr>
                        </tbody>
                    ))}
                </ListTable>
            </Modal>
            <Header>
                <h2>리뷰 목록</h2>

                {/* <Button type="deep" onClick={(e) => navigate(`/admin/review/create`)} style={{ width: "120px", height: "40px" }}>
                    리뷰 생성
                </Button> */}
                <IconCircle className="bi-plus" onClick={(e) => navigate(`/admin/review/create`)} alt="리뷰 생성" />
            </Header>
            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "55%" }}>제목</th>
                            <th style={{ width: "5%" }}>상태</th>
                            <th style={{ width: "15%" }}>진행도</th>
                            <th style={{ width: "10%" }}>생성 날짜</th>
                            <th style={{ width: "10%" }} className="center">기능</th>
                        </tr>
                    </thead>

                    <tbody>
                        {reviewList?.data?.review &&
                            reviewList?.data?.review.map((el) => {
                                let completeReviewerCount = 0;

                                el.reviewer.forEach((reviewer) => {
                                    if (reviewer.is_completed === "1") {
                                        completeReviewerCount++;
                                    }
                                });

                                const step = completeReviewerCount === 0 ? "0" : completeReviewerCount === el.reviewer.length ? "1" : "2"

                                return (
                                    <tr key={el.idx} className={`el.is_hide === "1" ? "is-hide" : "" hover-row`} onClick={() => reviewClickHander(el.idx, el.status)}>
                                        <td className="seq">{el.seq}</td>
                                        <td>
                                            <span className={`status status-${el.status}`}>{el.is_hide === "1" ? "삭제" : el.status === "1" ? "대기" : el.status === "2" ? "진행" : el.status === "3" ? "확인" : el.status === "4" ? "종료" : null}</span>
                                            {el.title}
                                            {el.is_public === "0" && (<IconLcok className="bi bi-lock-fill" />)}
                                        </td>
                                        <td className="center">
                                            <Select value={el.status} colorType={el.status} onChange={(e) => reviewStatusChangeHandler(e, el.idx)} onClick={(e) => e.stopPropagation()}>
                                                <SelectOption key={el.idx + "대기"} value={"1"}>
                                                    대기
                                                </SelectOption>
                                                <SelectOption key={el.idx + "진행"} value={"2"}>
                                                    진행
                                                </SelectOption>
                                                <SelectOption key={el.idx + "확인"} value={"3"}>
                                                    확인
                                                </SelectOption>
                                                <SelectOption key={el.idx + "종료"} value={"4"}>
                                                    종료
                                                </SelectOption>
                                            </Select>
                                        </td>
                                        <td>
                                            <StatusBadge step={step} />
                                            <ProgressSpan>{completeReviewerCount}/{el.reviewer.length}건</ProgressSpan>
                                        </td>
                                        <td className="date">{el.reg_date.split("T")[0]}</td>
                                        <td className="center">
                                            <Button
                                                type="main"
                                                onClick={(e) => {
                                                    reviewerOpenHandler(el);
                                                    e.stopPropagation();
                                                }}
                                                style={{ height: "30px" }}
                                            >
                                                리뷰어 보기
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </ListTable>
            </div>

            <Paging name={"admin_review_list"} total={parseInt(reviewList?.data?.total)} pageNumState={[pageNum, setPageNum]} viewCount={viewCount} />
        </>
    );
};

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ProgressSpan = styled.span`
    margin-left: 8px;
`;

const IconLcok = styled.i`
    margin: 0 0 0 8px;
    font-size: 0.75em;
    color: var(--lightgray-color);
`

export default ReviewList;